module.exports = __webpack_public_path__ + "img/logo.85c8c268.png";